import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import List from './list';

const GlobalSubcontractorsView = ({onDownloadExport}) => (
  <>
    <div className="row mb-5">
      <div className="col-md-8">
        <h1 className="m-0"><Translate value="globalSubcontractor.title"/></h1>
      </div>
      <div className="col-md-4 flex-container flex-end">
        <button
          data-id="download-export-button"
          className="primary large flex-container"
          onClick={onDownloadExport}
        >
          <Icon icon="folder-download"/>
          <Translate value="subcontractor.export"/>
        </button>
      </div>
    </div>
    <div className="card">
      <List/>
    </div>
  </>
);

GlobalSubcontractorsView.propTypes = {
  onDownloadExport: PropTypes.func.isRequired
};

export default GlobalSubcontractorsView;
